import Header from './header';
import Footer from './footer';
import styles from './layout.module.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
export default function Layout({ children }) {
    return (<div className={styles.container}>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>);
}
